/* eslint-disable */
// 通用 Module
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json
const state = {
  channel: null, // 登录状态
  activity: null, // 登录状态
};
const mutations = {
  setChannel (state, data) {
    state.channel = data;
  },
  setActivity (state, data) {
    state.activity = data;
  },
};
const getters = {
  getChannel: state => {
    return state.channel;
  },
  getActivity: state => {
    return state.activity;
  },
};
const actions = {
  // 直播禁止时间
  async updateLiveForbidTime ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveUpdateLiveForbidTimeCommandInput!){
          live{
            updateLiveForbidTime(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateLiveForbidTime",
      query: query,
      variables: {
        command: opt
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },
  // 修改直播
  async updateWeChat ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveUpdateWeChatCommandInput!){
          live{
            updateWeChat(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateWeChat",
      query: query,
      variables: {
        command: opt
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },
  // 修改直播
  async updateLive ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveUpdateCommandInput!){
          live{
            update(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateLive",
      query: query,
      variables: {
        command: opt
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },
  ExcelExportProduct ({ rootState, commit }, id) { // 直播产品统计导出
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Activity/ExcelExportProduct?activityId=${id}`, {}, {
        responseType: "arraybuffer",
        ...rootState.header
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        };
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  ExcelExportProduct ({ rootState, commit }, id) { // 直播产品统计导出
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Activity/ExcelExportProduct?activityId=${id}`, {}, {
        responseType: "arraybuffer",
        ...rootState.header
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        };
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  ExcelExportCompany ({ rootState, commit }, id) { // 企业店铺统计导出
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Activity/ExcelExportCompany?activityId=${id}`, {}, {
        responseType: "arraybuffer",
        ...rootState.header
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        };
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },
  ExcelExportUser ({ rootState, commit }, id) { // 直播用户导出
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Activity/ExcelExportUser?activityId=${id}`, {}, {
        responseType: "arraybuffer",
        ...rootState.header
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        };
      }).catch((err) => {
        console.log(err.response.data);
      });
    });
  },

  // 企业店铺统计
  async LiveViewProductLogPageQueryInput ({ dispatch }, opt) {
    let query = `#graphql
      query($query: LiveViewProductLogPageQueryInput!) {
        liveViewProductLogQuery{ 
          page(query: $query) { 
            page
            size 
            totalCount 
            items {
              keys
              activityId
              userId
              companyId
              productId
              releaseId
              shareCount
              collectCount
              inTime
              id
              companyName 
              product {
                keys
                compId
                name
                isDeleted
                id
              } 
              liveView {
                extendedProperties
                keys
                name
                phoneNumber
                gender
                companyName
                department
                jobTitle
                country
                province
                city
                county
                addressDetails
                isDeleted
                deleterId
                deletionTime
                lastModificationTime
                lastModifierId
                creationTime
                creatorId
                id
              }
              releaseContent
            }
          }
        }
      }
    `;
    let body = {
      queryName: "LiveViewProductLogPageQueryInput",
      query: query,
      variables: {
        query: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveViewProductLogQuery.page;
    return Promise.resolve(bool || null);
  },
  // 企业店铺统计
  async LiveViewCompanyLogPageQueryInput ({ dispatch }, opt) {
    let query = `#graphql
      query($query: LiveViewCompanyLogPageQueryInput!) {
        liveViewCompanyLogQuery{ 
          page(query: $query) { 
            page
            size 
            totalCount 
            items {
              keys
              activityId
              userId
              companyId
              productId
              inTime
              id
              companyName 
              product {
                keys
                compId
                name
                isDeleted
                id
              }
              liveView {
                extendedProperties
                keys
                name
                phoneNumber
                gender
                companyName
                department
                jobTitle
                country
                province
                city
                county
                addressDetails
                isDeleted
                deleterId
                deletionTime
                lastModificationTime
                lastModifierId
                creationTime
                creatorId
                id
              }
            }
          }
        }
      }
    `;
    let body = {
      queryName: "LiveViewCompanyLogCreateCommandInput",
      query: query,
      variables: {
        query: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveViewCompanyLogQuery.page;
    return Promise.resolve(bool || null);
  },
  async refreshSummary ({ dispatch }, id) {
    let query = `#graphql
      mutation($command: RefreshSummaryCommandInput!) {
        activityChannlIdSummary{ 
          refreshSummary(command: $command)
        }
      }
    `;
    let body = {
      queryName: "refreshSummary",
      query: query,
      variables: {
        command: {
          activityId: id
        }
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.activityChannlIdSummary.refreshSummary;
    return Promise.resolve(bool || null);
  },
  async getliveinfobyid ({ dispatch }, id) {
    let query = `#graphql
      query($activityId: UUID!) {
        activity{ 
          byId(activityId: $activityId) { 
            keys
            activityId
            polyUserId
            channelId
            name
            pcPlayDuration
            pcFlowSize
            pcVideoView
            pcUniqueViewer
            mobilePlayDuration
            mobileFlowSize
            mobileVideoView
            mobileUniqueViewer
            livePcPlayDuration
            playbackPcPlayDuration
            liveMobilePlayDuration
            playbackMobilePlayDuration
            unknownPcPlayDuration
            unknownMobilePlayDuration
            creatorName
            isDeleted
            id
          }
        }
      }
    `;
    let body = {
      queryName: "getliveinfobyid",
      query: query,
      variables: {
        activityId: id
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.activity.byId;
    return Promise.resolve(bool || null);
  },
  async pushUrlhandle ({ dispatch }, id) {
    let query = `#graphql
      mutation($channelId: String!) {
        live{ 
          pushUrl(channelId: $channelId)
        }
      }
    `;
    let body = {
      queryName: "pushUrl",
      query: query,
      variables: {
        channelId: id
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.live.pushUrl;
    return Promise.resolve(bool || null);
  },
  async removeVideo ({ dispatch }, opt) {
    let query = `#graphql
      mutation($command: LiveHistoryRemoveCommandInput!){
        liveHistory{ 
          removeVideo(command: $command)
        }
      }
    `;
    let body = {
      queryName: "removeVideo",
      query: query,
      variables: {
        command: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveHistory.removeVideo;
    return Promise.resolve(bool || null);
  },
  async refreshVodAndBlack ({ dispatch }, id) {
    let query = `#graphql
      mutation($command: LiveHistoryRefreshVodAndBlackCommandInput!){
        liveHistory{ 
          refreshVodAndBlack(command: $command)
        }
      }
    `;
    let body = {
      queryName: "refreshVodAndBlack",
      query: query,
      variables: {
        command: {
          activityId: id
        }
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveHistory.refreshVodAndBlack;
    return Promise.resolve(bool || null);
  },
  async convertVideo ({ dispatch }, opt) {
    let query = `#graphql
      mutation($command: LiveHistoryCoverCommandInput!){
        liveHistory{ 
          convertVideo(command: $command)
        }
      }
    `;
    let body = {
      queryName: "convertVideo",
      query: query,
      variables: {
        command: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveHistory.convertVideo;
    return Promise.resolve(bool || null);
  },
  async copyDate ({ dispatch }, opt) {
    let query = `#graphql
      mutation($command: LiveHistorySynchrodataCommandInput!){
        liveHistory{ 
          copyDate(command: $command)
        }
      }
    `;
    let body = {
      queryName: "copyDate",
      query: query,
      variables: {
        command: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveHistory.copyDate;
    return Promise.resolve(bool || null);
  },
  async getLiveHistoryQuery ({ dispatch }, opt) {
    let query = `#graphql
        query($query: LiveHistoryPageQueryInput!){
          liveHistory{
            page(query: $query) {
              hasNextPage
              totalCount 
               items {
                keys
                activityId
                channelId
                fileId
                url
                startTime
                endTime
                fileSize
                duration
                bitrate
                resolution
                channelSessionId
                fileName
                daysLeft
                origin
                originSessionId
                recordFileType
                inDate
                isConvert
                convertStatus
                videoId
                firstImage
                videoPoolId
                title
                status
                vodIsHad
                blackIsHad
                isDeleted
                id
                liveHistory {
                  keys
                  activityId
                  polyUserId
                  sessionId
                  channelId
                  startTime
                  endTime
                  isDeleted
                  id
                }
              }
            }
          }
        }
      `;
    let body = {
      queryName: "getLiveHistoryQuery",
      query: query,
      variables: {
        query: opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveHistory.page;
    return Promise.resolve(bool || null);
  },
  async getLiveLiveViewer ({ dispatch }, userId) {
    let query = `#graphql
        query($userId: UUID!){
          liveLiveViewer{
            get(userId: $userId) { 
              extendedProperties
              keys
              name
              gender
              companyName
              department
              phoneNumber
              jobTitle
              country
              province
              city
              county
              addressDetails
              isDeleted
              deleterId
              deletionTime
              lastModificationTime
              lastModifierId
              creationTime
              creatorId
              id
            }
          }
        }
      `;
    let body = {
      queryName: "getLiveLiveViewer",
      query: query,
      variables: {
        userId: userId
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveLiveViewer.get;
    return Promise.resolve(bool || null);
  },
  async getBannerList ({ dispatch }, opt) {
    let list = null;
    let query = `#graphql
    query {
      banner{
        all(type: "reg-form") { 
          type
          url
          showIndex 
          id
        }
      }
    }`;
    let option = {
      queryName: "getAllBanner",
      query: query,
    };
    let { data } = await dispatch("graphqlPost", option, { root: true });
    if (data.banner) {
      list = data.banner.all;
    }
    return Promise.resolve(list);
  },
  // 修改banner
  async patchBanner ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: BannerUpdateCommandInput!){
          banner{
            update(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateBanner",
      query: query,
      variables: {
        command: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.banner.update;
    return Promise.resolve(bool || null);
  },
  // 移除banner
  async delBanner ({ dispatch }, id) {
    let query = `#graphql
        mutation($command: BannerDeleteCommandInput!){
          banner{
            delete(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "delBanner",
      query: query,
      variables: {
        command: {
          id: id
        },
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.banner.delete;
    return Promise.resolve(bool || null);
  },
  // 新增banner
  async addBanner ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: BannerCreateCommandInput!){
          banner{
            create(command:$command)
          }
        }
      `;
    let body = {
      queryName: "createBanner",
      query: query,
      variables: {
        command: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.banner.create;
    return Promise.resolve(bool || null);
  },



  async getDepartmentList ({ dispatch }) {
    let list = null;
    let query = `#graphql
    query {
      department{
        all {
          name
          nameEn
          showIndex 
          id
          jobs {
            keys
            departmentId
            name
            nameEn
            showIndex 
            id
          }
        }
      }
    }`;
    let option = {
      queryName: "getAllDepartment",
      query: query,
    };
    let { data } = await dispatch("graphqlPost", option, { root: true });
    if (data.department) {
      list = data.department.all;
    }
    return Promise.resolve(list);
  },
  // 修改department
  async patchDepartment ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: DepartmentUpdateCommandInput!){
          department{
            update(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateDepartment",
      query: query,
      variables: {
        command: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.department.update;
    return Promise.resolve(bool || null);
  },
  // 移除department
  async delDepartment ({ dispatch }, id) {
    let query = `#graphql
        mutation($command: DepartmentDeleteCommandInput!){
          department{
            delete(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "delDepartment",
      query: query,
      variables: {
        command: {
          id: id
        },
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.department.delete;
    return Promise.resolve(bool || null);
  },

  // 新增department
  async addDepartment ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: DepartmentCreateCommandInput!){
          department{
            create(command:$command)
          }
        }
      `;
    let body = {
      queryName: "createDepartment",
      query: query,
      variables: {
        command: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.department.create;
    return Promise.resolve(bool || null);
  },



  async getDepartmentJobs ({ dispatch }, id) {
    let list = null;
    let query = `#graphql
    query  {
      departmentJob(departmentId: ${id}) {
        jobs { 
          departmentId
          name
          nameEn
          showIndex
          id
        }
      }
    }`;
    let option = {
      queryName: "getDepartmentJobs",
      query: query,
    };
    let { data } = await dispatch("graphqlPost", option, { root: true });
    if (data.departmentJob) {
      list = data.departmentJob.jobs;
    }
    return Promise.resolve(list);
  },
  // 修改departmentJob
  async patchDepartmentJob ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: DepartmentJobUpdateCommandInput!){
          departmentJob{
            update(command: $command)
          }
        }
      `;
    let body = {
      queryName: "updateDepartmentJob",
      query: query,
      variables: {
        command: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.departmentJob.update;
    return Promise.resolve(bool || null);
  },
  // 移除departmentJob
  async delDepartmentJob ({ dispatch }, id) {
    let query = `#graphql
        mutation($command: DepartmentJobDeleteCommandInput!){
          departmentJob{
            delete(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "delDepartmentJob",
      query: query,
      variables: {
        command: {
          id: id
        },
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.departmentJob.delete;
    return Promise.resolve(bool || null);
  },

  // 新增departmentJob
  async addDepartmentJob ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: DepartmentJobCreateCommandInput!){
          departmentJob{
            create(command:$command)
          }
        }
      `;
    let body = {
      queryName: "createDepartmentJob",
      query: query,
      variables: {
        command: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.departmentJob.create;
    return Promise.resolve(bool || null);
  },

  // 申请直播
  async applyLive ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveApplyCommandInput!){
          live{
            apply(command:$command)
          }
        }
      `;
    let body = {
      queryName: "applyLive",
      query: query,
      variables: {
        command: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.live.apply;
    return Promise.resolve(bool || null);
  },
  // 主办申请直播
  async dontAudit ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveDontAuditCommandInput!){
          live{
            dontAudit(command:$command)
          }
        }
      `;
    let body = {
      queryName: "dontAudit",
      query: query,
      variables: {
        command: opt,
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },

  // 获取直播审核 
  async getActivityLiveQuery ({ dispatch }, opt) {
    let query = `#graphql
        query($query: ActivityPagedQueryInput!){
          activity{
            page(query: $query) {
              page
              size 
              hasNextPage
              totalCount 
              items { 
                keys
                exhibitionId
                companyId
                joinId
                name
                nameEn
                isApplyLive
                liveApplyTime
                isOpenLive
                liveAudit
                liveAuditRemark
                liveAuditTime
                liveStartTime
                liveEndTime
                isOpenBlackLive
                liveLinkName
                livelinkTel
                liveChannelId
                liveWheatNumber
                liveSecretKey
                liveTemplate
                liveEnableNotDelay 
                isDeleted
                id
                companyName
              }
            }
          }
        }
      `;
    let body = {
      queryName: "getActivityLiveQuery",
      query: query,
      variables: {
        query: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.activity.page;
    return Promise.resolve(bool || null);
  },

  // 直播审核 
  async applyAudit ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveAuditCommandInput!){
          live{
            audit(command:$command)
          }
        }
      `;
    let body = {
      queryName: "applyAudit",
      query: query,
      variables: {
        command: opt,
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },


  // 获取直播间信息 channelId 
  async channelQuery ({ dispatch }, id) {
    let query = `#graphql
        query($request: PolyvLiveV4ChannelBasicGetRequestInput!){
          polyv{
            channel(request:$request)  {
              isSucceed
              data {
                name
                scene
                newScene
                template
                channelPasswd
                publisher
                startTime
                pageView
                likes
                coverImg
                splashImg
                splashEnabled
                bgImg
                desc
                consultingMenuEnabled
                maxViewerRestrict
                maxViewer
                watchStatus
                watchStatusText
                userCategory {
                  categoryId
                  categoryName
                  userId
                  rank
                }
                authSettings{
                  rank
                  userId
                  enabled
                  authType
                  authTips
                  payAuthTips
                  codeAuthTips
                  infoAuthTips
                  authCode
                  qCodeTips
                  qCodeImg
                  price
                  watchEndTime
                  validTimePeriod
                  customKey
                  customUri
                  externalKey
                  externalUri
                  externalRedirectUri
                  directKey
                  trialWatchEnabled
                  trialWatchTime
                  trialWatchEndTime
                  whiteListInputTips
                  whiteListEntryText
                  infoDesc
                  customTeacherId
                }
                linkMicLimit
              }
              code
              message
              status
              statusCode
              error {
                code
                desc
              }
            }
          }
        }
      `;
    let body = {
      queryName: "channelQuery",
      query: query,
      variables: {
        request: {
          channelId: id
        },
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.channel;
    return Promise.resolve(bool || null);
  },
  async authSign ({ dispatch }, opt) {
    let query = `#graphql
        query($userid: UUID!, $channelId: String!){
          polyv{
            authSign(userid:$userid,channelId: $channelId )  {
              sign
              ts 
            }
          }
        }
      `;
    let body = {
      queryName: "authSign",
      query: query,
      variables: opt
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.authSign;
    return Promise.resolve(bool || null);
  },
  // 修改引导图
  async channelSettingUpdateSplash ({ dispatch }, opt) {
    let query = `#graphql
        mutation($request: PolyvLiveV2ChannelSettingSetSplashRequestInput!){
          polyv{
            channelSettingUpdateSplash(request:$request) { 
              isSucceed
              data
              code
              message
              status
              success
              statusCode
              error {
                code
                desc
              }
            }
          }
        }
      `;
    let body = {
      queryName: "channelSettingUpdateSplash",
      query: query,
      variables: {
        request: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.channelSettingUpdateSplash;
    return Promise.resolve(bool || null);
  },


  // 获取直播间角色信息
  async allByActivityId ({ dispatch }, opt) {
    let query = `#graphql
        query($query: ActivityLiveMemberPageQueryInput!){
          polyv{
            allByActivityId(query:$query)  {
              page
              size
              hasPreviousPage
              hasNextPage
              totalCount
              totalPages
              items {
                keys
                activityId
                account
                polyUserId
                channelId
                passwd
                nickname
                sort
                avatar
                actor
                role
                monitorEnabled
                pageTurnEnabled
                chatListEnabled
                chatAuditEnabled
                inTime
                inDate
                upTime
                isDeleted
                id
              }
            }
          }
        }
      `;
    let body = {
      queryName: "allByActivityId",
      query: query,
      variables: {
        query: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.allByActivityId;
    return Promise.resolve(bool || null);
  },

  // 移除角色
  async deleteMember ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: ActivityLiveMemberDeleteCommandInput!){
          polyv{
            deleteMember(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "deleteMember",
      query: query,
      variables: {
        command: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.deleteMember;
    return Promise.resolve(bool || null);
  },

  // 新增角色
  async createMember ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: ActivityLiveMemberCreateCommandInput!){
          polyv{
            createMember(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "createMember",
      query: query,
      variables: {
        command: opt,
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },

  // 编辑角色
  async updateMember ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: ActivityLiveMemberUpdateCommandInput!){
          polyv{
            updateMember(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "updateMember",
      query: query,
      variables: {
        command: opt,
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },
  // 编辑讲师
  async updateTeacher ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: ActivityLiveMemberUpdateTeacherCommandInput!){
          polyv{
            updateTeacher(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "updateTeacher",
      query: query,
      variables: {
        command: opt,
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.updateTeacher;
    return Promise.resolve(bool || null);
  },


  // 获取直播间产品
  async channelProductAll ({ dispatch }, opt) {
    let query = `#graphql
        query($request: PolyvLiveV3ChannelProductListRequestInput!){
          polyv {
            channelProductAll(request:$request) {
              isSucceed
              data {
                pageSize
                pageNumber
                totalItems 
                firstPage
                lastPage
                prePageNumber
                nextPageNumber
                limit
                totalPages
                endRow
                offset
                contents  {
                  productId
                  userId
                  channelId
                  name
                  price
                  cover
                  link 
                }
              }
              code
              message
              status
              success 
              statusCode
              error {
                code
                desc
              }
            }
          }
        }
      `;
    let body = {
      queryName: "channelProductAll",
      query: query,
      variables: {
        request: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.channelProductAll.data;
    return Promise.resolve(bool || null);
  },

  // 移除直播间产品
  async channelProductDelete ({ dispatch }, id) {
    let query = `#graphql
        mutation($request: PolyvLiveV3ChannelProductDeleteRequestInput!){
          polyv{
            channelProductDelete(request:$request) { 
              isSucceed
              code
              message
              status
              success 
              statusCode
              error {
                code
                desc
              }
            }
          }
        }
      `;
    let body = {
      queryName: "channelProductDelete",
      query: query,
      variables: {
        request: {
          id: id
        },
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.polyv.channelProductDelete;
    return Promise.resolve(bool || null);
  },
  // 添加直播间产品
  async transportProduct ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: TransportProductCommandInput!){
          polyv{
            transportProduct(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "transportProduct",
      query: query,
      variables: {
        command: opt
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    return Promise.resolve(data || null);
  },
  // 添加直播间产品
  async removeTransportProduct ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: RemoveTransportProductCommandInput!){
          polyv{
            removeTransportProduct(command:$command) 
          }
        }
      `;
    let body = {
      queryName: "removeTransportProduct",
      query: query,
      variables: {
        command: opt
      },
    };
    let data = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data;
    return Promise.resolve(bool || null);
  },

  // 创建或更新直播观众信息
  async createOrUpdate ({ dispatch }, opt) {
    let query = `#graphql
        mutation($command: LiveViewerCreateOrUpdateCommandInput!){
          liveLiveViewer{
            createOrUpdate(command:$command) 
          } 
        }
      `;
    let body = {
      queryName: "createOrUpdate",
      query: query,
      variables: {
        command: opt
      },
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveLiveViewer.createOrUpdate;
    return Promise.resolve(bool || null);
  },

//   直播人员统计
async liveBroadcastUserSummary ({ dispatch }, opt) {
    let query = `#graphql
      mutation($command: LiveViewUserLogCreateCommandInput!) {
        liveViewUserLogsMutation{ 
            create(command: $command)
        }
      }
    `;
    let body = {
      queryName: "liveBroadcastUserSummary",
      query: query,
      variables: {
        command:opt
      }
    };
    let { data } = await dispatch("graphqlPost", body, {
      root: true,
    });
    let bool = data.liveViewUserLogsMutation.create;
    return Promise.resolve(bool || null);
  },

    // 直播人员统计
    async LiveViewUserLogPageQueryInput ({ dispatch }, opt) {
        let query = `#graphql
          query($query: LiveViewUserLogPageQueryInput!) {
            liveViewUserLogQuery{ 
              page(query: $query) { 
                page
                size 
                totalCount 
                items {
                  keys
                  activityId
                  userId
                  inTime
                  id
                  liveView {
                    keys
                    name
                    phoneNumber
                    gender
                    companyName
                    department
                    jobTitle
                    country
                    province
                    city
                    county
                    addressDetails
                    isDeleted
                    deleterId
                    deletionTime
                    lastModificationTime
                    lastModifierId
                    creationTime
                    creatorId
                    id
                  }
                }
              }
            }
          }
        `;
        let body = {
          queryName: "LiveViewUserLogPageQueryInput",
          query: query,
          variables: {
            query: opt
          }
        };
        let { data } = await dispatch("graphqlPost", body, {
          root: true,
        });
        let bool = data.liveViewUserLogQuery.page;
        return Promise.resolve(bool || null);
      },


};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
